var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"title-wrap"},[_c('v-col',{staticClass:"icon-title",attrs:{"cols":"12"}},[_c('icon-work-day',{attrs:{"width":22,"height":22}}),_vm._v(_vm._s('기준일자를 선택해 주세요'))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }